import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  selectedTableRowsIdsAtomFamily,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkRideCancel = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkCancelRidesProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkRideCancel,
    entity,
  );
  const setSelectedTableRowsIdsAtomFamily = useSetRecoilState(
    selectedTableRowsIdsAtomFamily(entity),
  );
  const bulkCancelRidesProcess = useRecoilValue(
    activeProcessSF(bulkCancelRidesProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
      setSelectedTableRowsIdsAtomFamily(prev => {
        const successIds = process.metadata?.metrics?.successIds;
        if (!successIds?.length) {
          return prev;
        }
        const successIdsSet = new Set(successIds);
        return prev.filter(id => !successIdsSet.has(id));
      });
    },
    [addressedFieldsValueOnCompleted, setSelectedTableRowsIdsAtomFamily],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkRideCancel,
      process: bulkCancelRidesProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
      toastSummaryOnComplete: true,
    });
  }, [bulkCancelRidesProcess, entity, onComplete, stopProcessPolling, t]);
};
